import React, {Component} from 'react';
import './cameraButton.css';
import '../main_button/MainButton'
import MainButton from '../main_button/MainButton';

class CameraButton extends Component {
    constructor(props){
        super(props);
        this.state = {
            clicked: false,
        };
        this.launchCameraButton = this.launchCameraButton.bind(this);
    }

    render() {
        return (
            <div className={'camera-button'}>
                <input ref={input => this.fileInput = input}
                    type={'file'}
                    accept={'image/*'}
                    capture={'camera'}
                    style={{display: 'none'}}
                    onChange={(event) => this.props.getImage(event, this.fileInput)}
                />
                <MainButton
                    outline={this.props?.outline || false}
                    onClick={this.launchCameraButton}
                    text={this.props.text}
                    class={this.props.class}
                >
                </MainButton>
            </div>
        );
    }

    launchCameraButton = () => {
        this.setState({clicked: true});
        this.props.launchCamera(this.fileInput);
    }
}

export default CameraButton;

